import { createActionGroup, props } from '@ngrx/store';
import type { LocationAllowedOsUpdate } from '@rocksoft/shared';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const LocationAllowedOsUpdatesResolverActions = createActionGroup({
  source: 'Location Allowed OS Updates resolver',
  events: {
    requested: props<{ locationId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const LocationAllowedOsUpdatesApiActions = createActionGroup({
  source: 'Location Allowed OS Updates API',
  events: {
    loaded: props<{ locationAllowedOsUpdates: LocationAllowedOsUpdate[] }>(),
    'loaded error': props<{ error: ErrorModel }>(),
    updated: props<{ locationId: string; locationAllowedOsUpdates: LocationAllowedOsUpdate[] }>(),
    'updated error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CurrentLocationViewActions = createActionGroup({
  source: 'Current location view',
  events: {
    Update: props<{ locationId: string; locationAllowedOsUpdates: LocationAllowedOsUpdate[] }>(),
  },
});
